/* EverWag motion: scroll reveals, header state, hero parallax, situation finder, lazy videos. No dependencies. */
(function () {
  window.__ewMotion = true;
  var d = document;
  var root = d.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Hero entrance: rAF for smoothness, timer as a fallback (rAF pauses in background tabs) */
  function ready() { root.classList.add('ew-ready'); }
  window.requestAnimationFrame(ready);
  setTimeout(ready, 80);

  /* Staggered children get an index for CSS delays */
  d.querySelectorAll('[data-ew-stagger]').forEach(function (parent) {
    Array.prototype.forEach.call(parent.children, function (child, i) {
      child.style.setProperty('--ew-i', i);
    });
  });

  /* Scroll reveals */
  var revealEls = Array.prototype.slice.call(d.querySelectorAll('[data-ew-reveal]'));
  if (reduce || !('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) { el.classList.add('ew-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ew-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    revealEls.forEach(function (el) { io.observe(el); });
    /* Safety net: anything already on screen is revealed even if the observer is slow */
    setTimeout(function () {
      revealEls.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('ew-in');
      });
    }, 2500);
  }

  /* Lazy videos: load and play only while on screen; reduced-motion visitors get a play button instead */
  var vids = Array.prototype.slice.call(d.querySelectorAll('video[data-ew-video]'));
  vids.forEach(function (v) { v.muted = true; if (reduce) v.setAttribute('controls', ''); });
  if (!reduce && vids.length) {
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            if (v.preload === 'none') v.preload = 'auto';
            var p = v.play();
            if (p && p.catch) p.catch(function () { v.setAttribute('controls', ''); });
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.25 });
      vids.forEach(function (v) { vio.observe(v); });
    } else {
      vids.forEach(function (v) { v.setAttribute('controls', ''); });
    }
  }

  /* Header state + hero parallax (one rAF-throttled scroll handler) */
  var parallaxEls = reduce ? [] : Array.prototype.slice.call(d.querySelectorAll('[data-ew-parallax]'));
  var ticking = false;
  function update() {
    ticking = false;
    root.classList.toggle('ew-scrolled', window.scrollY > 12);
    if (!parallaxEls.length) return;
    var vh = window.innerHeight;
    parallaxEls.forEach(function (el) {
      var box = el.parentElement.getBoundingClientRect();
      if (box.bottom < 0 || box.top > vh) return;
      var speed = parseFloat(el.getAttribute('data-ew-parallax')) || 0.12;
      el.style.transform = 'translate3d(0,' + (box.top * -speed).toFixed(1) + 'px,0)';
    });
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }, { passive: true });
  update();

  /* Situation finder tabs (accessible: arrow keys, aria-selected) */
  d.querySelectorAll('[data-ew-tabs]').forEach(function (wrap) {
    var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[data-ew-tab]'));
    var panels = Array.prototype.slice.call(wrap.querySelectorAll('[data-ew-panel]'));
    var list = wrap.querySelector('.ew-finder__tabs');
    function show(id, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-ew-tab') === id;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus({ preventScroll: true });
        if (on && list && list.scrollWidth > list.clientWidth + 4) {
          list.scrollTo({ left: t.offsetLeft - 20, behavior: reduce ? 'auto' : 'smooth' });
        }
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-ew-panel') === id;
        p.hidden = !on;
        if (on) { p.classList.remove('ew-panel-in'); void p.offsetWidth; p.classList.add('ew-panel-in'); }
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(t.getAttribute('data-ew-tab')); });
      t.addEventListener('keydown', function (e) {
        var j = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % tabs.length;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + tabs.length) % tabs.length;
        if (j !== null) { e.preventDefault(); show(tabs[j].getAttribute('data-ew-tab'), true); }
      });
    });
  });
})();
